import * as React from "react";
import protectedRoute from "./protectedRoute";
import { styled, createTheme } from "@mui/material/styles";
import Container from "@mui/material/Container";
import HomeBar from "./HomeBar";
import {
  CssDataJacketTitleTypography,
  CssDataJacketBodyTypography,
} from "./styles/styled";
import { useLocation } from "react-router-dom";
import {
  getFavoriteAllDataJacket,
  MyDataJacketIDList,
} from "./js/queriesHandling";
import Box from "@mui/material/Box";
import { Auth, Hub } from "aws-amplify";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import { grey } from "@mui/material/colors";
import { PaginationItem } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import MenuItem from "@mui/material/MenuItem";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import IconButton from "@mui/material/IconButton";
import { MainPageBox } from "./styles/styled";
import { MyDataJacketCardComponent } from "./components/other/mydataJacketCard";
import Typography from "@mui/material/Typography";
import datauniverseImg from "./images/Image20230928142439.png";
import Footer from "./Footer";

const customTheme = createTheme({
  palette: {
    primary: {
      main: "#171717",
      sub: grey[50],
      light: grey[50],
      dark: grey[900],
      constrastText: grey[50],
    },
    secondary: {
      main: grey[900],
    },
  },
});

const DataJacketPagination = styled(Pagination)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.light,
  "& .MuiPaginationItem-text": {
    color: theme.palette.primary.light,
  },
}));

const options = ["登録日降順", "登録日昇順"];

function Mydatajacket(props) {
  const [page, setPage] = React.useState([]);
  const [displayJacket, setDisplayJacket] = React.useState(false);
  const [displayPaging, setDisplayPaging] = React.useState(false);
  const [totalJackets, setTotalJackets] = React.useState(0);
  const [pages, setPages] = React.useState(0);
  const [arrDataJacket, setArrDataJacket] = React.useState([]);
  const [user, setUser] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [compDataJacket, setCompDataJacket] = React.useState([]);
  const [prevSortOrder, setPrevSortOrder] = React.useState(options[0]);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [maxHeight, setMaxHeight] = React.useState(0);
  const ref = React.useRef([]);
  const [deleteData, setDeleteData] = React.useState([]);

  const handleSetDeleteData = (deleteId) => {
    setDeleteData(deleteId);
  };

  const handleMenuItemClick = (event, index) => {
    setPrevSortOrder(options[selectedIndex]);
    setCurrentPage(1);
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    try {
      setTimeout(function () {
        if (true) {
          let currentMaxHeight = 0;
          for (let i = 0; i < compDataJacket.length; i++) {
            if (i === 0) {
              currentMaxHeight = ref[i].offsetHeight;
            } else if (ref[i].offsetHeight > currentMaxHeight) {
              currentMaxHeight = ref[i].offsetHeight;
            }
          }
          setMaxHeight(currentMaxHeight);
          if (maxHeight > 0) {
            for (let i = 0; i < compDataJacket.length; i++) {
              ref[i].style.height = currentMaxHeight + "px";
            }
          }
        }
      }, 1000);
    } catch (e) {}
  }, [compDataJacket, pathname, maxHeight]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (user && options[selectedIndex] !== prevSortOrder) {
      searchJacket();
    }
  }, [selectedIndex]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    MyDataJacketIDList(value, user ? user.username : "", options[selectedIndex])
      .then((evt) => {
        setArrDataJacket(evt);
      })
      .catch((err) => {});
  };

  const searchJacket = () => {
    setCurrentPage(1);
    MyDataJacketIDList(0, user ? user.username : "", options[selectedIndex])
      .then((evt) => {
        if (evt.length === 1 && evt[0] === "") {
          processErrorOrNoResult();
        } else {
          if (evt.length > 12) {
            setDisplayPaging(true);
            setPages(Math.ceil(evt.length / 12));
          } else {
            setDisplayPaging(false);
            setPages(0);
          }
          let arrFirstPageIds = [12];
          for (var i = 0; i < evt.length && i < 12; i++) {
            arrFirstPageIds[i] = evt[i];
          }
          setArrDataJacket(arrFirstPageIds);
          setTotalJackets(evt.length);
        }
      })
      .catch((err) => {
        processErrorOrNoResult();
      });
    setDisplayJacket((prev) => (prev === false ? !prev : prev));
  };

  function processErrorOrNoResult() {
    setCompDataJacket(
      <CssDataJacketTitleTypography>
        該当結果がありません。
      </CssDataJacketTitleTypography>
    );
    setCurrentPage(0);
    setTotalJackets(0);
    setDisplayPaging(false);
  }

  async function checkUser() {
    try {
      const data = await Auth.currentUserPoolUser();
      const userInfo = { username: data.username, ...data.attributes };
      setUser(userInfo);
      Auth.currentSession().then().catch();
    } catch (err) {}
  }

  React.useEffect(() => {
    try {
      if (user) {
        searchJacket();
      }
    } catch {}
  }, [user]);

  React.useEffect(() => {
    try {
      if (user) {
        searchJacket();
        getDataJacketIds();
      }
    } catch {}
  }, [deleteData]);

  const getDataJacketIds = () => {
    MyDataJacketIDList(page, user ? user.username : "", options[selectedIndex])
      .then((evt) => {
        if (selectedIndex !== 0) {
          setArrDataJacket(evt);
        }
      })
      .catch((err) => {});
  };

  async function renderPaging() {
    if (
      pages === 0 ||
      displayJacket === false ||
      displayPaging === false ||
      totalJackets < 12
    ) {
      return <></>;
    } else {
      return (
        <Box
          component="span"
          style={{
            display: "block",
            paddingTop: "32px",
            paddingBottom: "32px",
          }}
        >
          <Grid
            container
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid container item>
              <CssDataJacketBodyTypography>Page</CssDataJacketBodyTypography>
            </Grid>
            <Grid container item>
              <DataJacketPagination
                style={{
                  backgroundColor: "#505458",
                }}
                theme={customTheme}
                count={pages}
                defaultPage={1}
                boundaryCount={2}
                page={currentPage}
                onChange={handlePageChange}
                renderItem={(item) => (
                  <PaginationItem
                    components={{
                      previous: ArrowBackIosIcon,
                      next: ArrowForwardIosIcon,
                    }}
                    {...item}
                    sx={{
                      color: "white",
                      "&.Mui-selected": {
                        backgroundColor: "#75787B",
                        color: "white",
                        borderColor: "transparent",
                        fontSize: 16,
                        height: "32px",
                        width: "32px",
                        borderRadius: "20px",
                      },
                      "&.MuiPaginationItem-root:hover": {
                        backgroundColor: "#75787B",
                      },
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Box>
      );
    }
  }

  async function getDataJacket() {
    try {
      const returnDataJacket = await getFavoriteAllDataJacket(
        ["0000"].concat(arrDataJacket)
      );
      setCompDataJacket(
        returnDataJacket.map((djInfo, index) => (
          <MyDataJacketCardComponent
            key={djInfo.key}
            jacketId={djInfo.myDataJacketList.my_data_jacket_id}
            myDataJacketList={djInfo.myDataJacketList}
            setDeleteData={handleSetDeleteData}
            ref={(el) => (ref[index] = el)}
          />
        ))
      );
      setPage(await renderPaging());
    } catch {}
  }

  React.useEffect(() => {
    try {
      checkUser();
      Hub.listen("auth", (data) => {
        const { payload } = data;
        if (payload.event === "signOut") {
          setUser(null);
        }
      });
    } catch {}
  }, []);

  React.useEffect(() => {
    try {
      if (
        (arrDataJacket.length > 0 || totalJackets > 0) &&
        displayJacket === true
      ) {
        getDataJacket();
      }
    } catch {}
  }, [arrDataJacket]);

  React.useEffect(() => {
    try {
      if (displayPaging === false) {
        setPage(<></>);
      }
    } catch {}
  }, [displayPaging]);

  return (
    <React.Fragment>
      <HomeBar />
      <Box
        style={{
          padding: "0",
          height: "400px",
          minWidth: "1200px",
        }}
      >
        <img
          alt="メインバックグラウンド"
          src={datauniverseImg}
          style={{
            height: "400px",
            width: "100%",
            objectFit: "cover",
          }}
        />
      </Box>
      <Box
        style={{
          height: "50px",
          paddingLeft: "20px",
        }}
      >
        <Typography
          style={{
            color: "white",
            fontSize: "24px",
            fontWeight: "bold",
            marginLeft: "32px",
            paddingTop: "20px",
            fontFamily: "Noto Sans JP, Meiryo, -apple-system",
          }}
        >
          DATA JACKET
        </Typography>
      </Box>
      <Container
        style={{
          backgroundColor: "#303234",
          minWidth: "1200px",
        }}
        maxWidth={false}
      >
        <MainPageBox>
          <Box
            component="span"
            style={{
              display: "flex",
              alignItems: "right",
              justifyContent: "right",
              marginTop: "8px",
              marginRight: "16px",
              marginBottom: "12px",
              height: "48px",
            }}
          >
            <IconButton
              style={{ fontSize: "16px", marginTop: 0, color: "white" }}
              sx={{
                "&:hover": {
                  backgroundColor: "#75787B",
                },
                borderRadius: "5px",
              }}
              size="medium"
              ref={anchorRef}
              aria-controls={open ? "split-button-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-label="select merge strategy"
              aria-haspopup="menu"
              onClick={handleToggle}
            >
              <VerticalAlignBottomIcon />
              {options[selectedIndex]}
            </IconButton>
            <Popper
              sx={{
                zIndex: 1,
              }}
              open={open}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper style={{ backgroundColor: "#505458", color: "white" }}>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList id="split-button-menu" autoFocusItem>
                        {options.map((option, index) => (
                          <MenuItem
                            sx={{
                              "&:hover": {
                                backgroundColor: "#75787B",
                              },
                              "&.MuiMenuItem-root.Mui-selected": {
                                backgroundColor: "#75787B",
                              },
                            }}
                            key={option}
                            selected={index === selectedIndex}
                            onClick={(event) =>
                              handleMenuItemClick(event, index)
                            }
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
            <CssDataJacketBodyTypography
              style={{
                fontSize: "16px",
                display: "inline",
                marginLeft: "0",
                marginTop: "4px",
              }}
            >
              {parseInt(totalJackets) > 0
                ? (currentPage - 1) * 12 +
                  1 +
                  "-" +
                  (currentPage * 12 > parseInt(totalJackets)
                    ? parseInt(totalJackets)
                    : currentPage * 12)
                : "0"}
              /{parseInt(totalJackets) > 0 ? parseInt(totalJackets) : "0"} 表示
            </CssDataJacketBodyTypography>
          </Box>
          <Grid
            style={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
              paddingLeft: "32px",
              paddingRight: "32px",
            }}
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 6, sm: 9, md: 9 }}
          >
            {compDataJacket}
          </Grid>
          {page}
        </MainPageBox>
        <Box
          style={{
            backgroundColor: "#505458",
            overflowY: "scroll",
            scrollbarWidth: "thin",
          }}
        ></Box>
      </Container>
      <Box
        style={{
          marginTop: "50px",
        }}
      >
        <Footer />
      </Box>
    </React.Fragment>
  );
}

export default protectedRoute(Mydatajacket);
